module.exports = __webpack_public_path__ + "static/media/hodiny.c3fabd7d.jpg";